import { cloneBiddingSummaryExportRoot } from 'components/molecules/bidding_summary_export_dom';
import { biddingSummaryShareEmailStyles } from 'components/organisms/bidding_summary/styles';

function absolutizeImgSrcInHtml(html: string): string {
  if (typeof window === 'undefined') return html;
  const { origin } = window.location;

  return html.replace(
    /<img\b([^>]*?)\bsrc\s*=\s*(["'])([^"']*)\2/gi,
    (_m, pre: string, q: string, src: string) => {
      const s = src.trim();
      if (!s || /^https?:/i.test(s) || s.startsWith('data:')) {
        return `<img${pre}src=${q}${src}${q}`;
      }
      const abs = s.startsWith('//')
        ? `https:${s}`
        : `${origin}${s.startsWith('/') ? '' : '/'}${s}`;
      return `<img${pre}src=${q}${abs}${q}`;
    },
  );
}

const EMAIL_BANNER_HTML = '<div class="email-summary-banner">CONLICITAÇÃO - RESUMO DO EDITAL</div>';

function cloneSummaryHtmlWithoutIcons(root: HTMLElement): string {
  return cloneBiddingSummaryExportRoot(root).innerHTML;
}

export function buildBiddingSummaryShareHtml(root: HTMLElement | null): string {
  if (!root) return '';

  const inner = absolutizeImgSrcInHtml(cloneSummaryHtmlWithoutIcons(root));

  return `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" crossorigin="anonymous" />
<style>
${biddingSummaryShareEmailStyles}
</style>
</head>
<body>
${EMAIL_BANNER_HTML}
<div class="bidding-summary-email-root">
${inner}
</div>
</body>
</html>`;
}
